import { Component, Input, Output, EventEmitter, OnDestroy, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SubSink } from 'subsink';
import { ERRORS } from '../../models/constants';
@Component({
  selector: 'app-password-toggle-control',
  templateUrl: './password-toggle.component.html'
})
export class PasswordToggleControlComponent implements OnChanges, OnDestroy {
  @Input() fieldControl;
  @Input() form;
  @Input() type;
  @Input() isBundle?: boolean;
  @Output() controlReady = new EventEmitter<boolean>();
  passwordToogle: boolean;
  @Input() parentScope: any;
  @Input() dynamicControlScope: any;
  private eventSubscriptionsList: SubSink;
  constructor() {}

  /**
   * A callback method that is invoked if any data-bound properties change
   */
  ngOnChanges() {
    this.eventSubscriptionsList = new SubSink();
    this.registerEvents();
  }
  // tslint:disable-next-line: completed-docs
  ngOnDestroy() {
    if (this.eventSubscriptionsList) {
      this.eventSubscriptionsList.unsubscribe();
    }
  }
  /**
   * This method will register the events
   * NOTE: Sequence of function calls need to be exactly same as below
   */
  private async registerEvents() {
    try {
      await this.registerChangeEmitterEvent(this.fieldControl, this.form);
      this.notifyControlLoadComplete();
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * This method will notify when control is ready
   */
  private notifyControlLoadComplete() {
    this.controlReady.emit(true);
  }
  /**
   * getter function to check mandatory fields
   */
  get isMandatory(): boolean {
    try {
      return this.fieldControl.validations.mandatory.value;
    } catch (error) {
      return false;
    }
  }
  /**
   * This method will register dropdown value changes
   */
  private registerChangeEmitterEvent(field: object, form: FormGroup) {
    try {
      if (!field.hasOwnProperty('onChangeEvent') || field['onChangeEvent'].length === 0) {
        return;
      }
      for (const eventSchema of field['onChangeEvent']) {
        this.eventSubscriptionsList.sink = form.get(field['logicalName']).valueChanges.subscribe((value) => {
          this.callFunctionByName(eventSchema.functionName, field, value, form, eventSchema.params)
            .catch((err) => console.log(err))
            .then((val) => console.log(val));
        });
      }
      return true;
    } catch (error) {
      throw error;
    }
  }
  /**
   * This method will call the schema functions by name
   */
  async callFunctionByName(fnName: string, ...params: any) {
    try {
      let scope: any;
      if (this[fnName]) {
        scope = this;
      } else if (this.dynamicControlScope[fnName]) {
        scope = this.dynamicControlScope;
      } else if (this.parentScope[fnName]) {
        scope = this.parentScope;
      } else {
        throw new Error(ERRORS.FUNCTION_NOT_FOUND);
      }
      params ? scope[fnName](...params) : scope[fnName]();
    } catch (error) {
      throw new Error(`${ERRORS.FUNCTION_CALL_FAILED}: ${error}`);
    }
    return true;
  }
}
